import * as THREE from 'three';
import { isOverlay } from './edges';

// Casting against every triangle of a scan-sized mesh on each wheel tick or
// pointer move stutters the view.
export const MAX_CAST_TRIANGLES = 250_000;

// A press that travels further than this is an orbit or a pan, not a click.
export const CLICK_SLOP_PX = 5;

export function isModelMesh(object: THREE.Object3D): object is THREE.Mesh {
  return (object as THREE.Mesh).isMesh === true && !isOverlay(object);
}

export function triangleCount(model: THREE.Object3D): number {
  let count = 0;
  model.traverse((child) => {
    if (!isModelMesh(child)) return;
    const { index } = child.geometry;
    count += (index ? index.count : child.geometry.getAttribute('position').count) / 3;
  });
  return count;
}

/** The nearest hit on the model's own faces that a section plane has not cut away. */
export function modelHit(
  raycaster: THREE.Raycaster,
  model: THREE.Object3D,
  clip: THREE.Plane | null,
): THREE.Intersection | undefined {
  return raycaster
    .intersectObject(model, true)
    .find(({ object, point }) => isModelMesh(object) && (!clip || clip.distanceToPoint(point) >= 0));
}
